import { BrainCircuit, ShieldCheck, UserRound } from "lucide-react";
import type { SignInAudience } from "@/lib/auth-redirect";

const OPTIONS: Array<{
  audience: SignInAudience;
  label: string;
  description: string;
  icon: typeof UserRound;
}> = [
  {
    audience: "member",
    label: "Member sign in",
    description: "Your nutrition dashboard",
    icon: UserRound,
  },
  {
    audience: "admin",
    label: "Admin sign in",
    description: "Health administration",
    icon: ShieldCheck,
  },
  {
    audience: "coach",
    label: "Coach sign in",
    description: "Coach AI workspace",
    icon: BrainCircuit,
  },
];

export function RoleSignInChooser({
  activeAudience,
  onSelect,
}: {
  activeAudience: SignInAudience;
  onSelect: (audience: SignInAudience) => void;
}) {
  return (
    <div
      aria-label="Choose sign-in destination"
      className="mb-3 grid grid-cols-1 gap-2 sm:grid-cols-3"
      data-testid="role-sign-in-options"
      role="group"
    >
      {OPTIONS.map((option) => {
        const active = activeAudience === option.audience;
        const Icon = option.icon;

        return (
          <button
            aria-pressed={active}
            className={`min-h-12 rounded-xl border px-3 py-2.5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-[#050508] ${
              active
                ? "border-primary/50 bg-primary/10 text-white"
                : "border-white/[0.08] bg-white/[0.025] text-white/60 hover:border-white/20 hover:bg-white/[0.05] hover:text-white"
            }`}
            key={option.audience}
            onClick={() => onSelect(option.audience)}
            type="button"
          >
            <span className="flex items-center gap-2 text-xs font-semibold">
              <Icon aria-hidden="true" className={`h-4 w-4 ${active ? "text-primary" : "text-white/45"}`} />
              {option.label}
            </span>
            <span className="mt-1 block pl-6 text-[10px] leading-tight text-white/35">
              {option.description}
            </span>
          </button>
        );
      })}
    </div>
  );
}